import React, { useState, useRef, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import {
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  HBNEXT_ORG_ID,
  ROW_PER_PAGE_SIZE,
  PAGE_SIZE,
} from "../../../../constant/constant";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import {
  ADMIN_ADD_STORM_WATERPROJECT,
  ADMIN_SW_VIEW_PROJECT,
  SW_ADD_PERMIT,
  SW_ADMIN_SAMPLINGLOG,
} from "../../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Button, Grid, Popover, Typography, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import SiteFilter from "./siteFilter";
import { getFormatedDate, InactiveClient } from "../../../../utils/helper";
import {
  checkPrivileges,
  isSwClientManager,
} from "../../../../utils/rolesHelper";
import DialogBox from "../../../../library/common/DialogBox";
import QrCodeDownload from "./QrCodeDownload";
import { toast } from "react-toastify";
import { useDebounce } from "../../../../utils/useDebounceSearch";

export default function SwProjectList({
  state,
  swProjectLists,
  swProjectListData,
  isLoading,
  searchClient,
  autoSearchDataLoading,
  searchAllClientsReducerData,
  onSearchSite,
  searchSitedata,
  divisionId,
  deleteSWProject,
  shouldRestoreState,
  stateList,
}) {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [clientSearch, setClientSearch] = useState("");
  const debouncedClientSearch = useDebounce(clientSearch, 500);
  const [siteSearch, setSiteSearch] = useState("");
  const debouncedSiteSearch = useDebounce(siteSearch, 500);

  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clients, setClients] = useState();
  const [siteName, setSiteName] = useState("");
  const [searchdata, setSearchdata] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [projectName, setProjectName] = useState("");
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const autoCompGroup = useRef(null);

  // Only change: SW Client Manager stays on its own org, even inside HBNext (1).
  // Everything below the first branch is the previous logic, unchanged.
  const swCustomerId = isSwClientManager()
    ? ORG_ID()
    : parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)
      ? 0
      : ORG_ID();

  const [swProjectListApiData, setSwProjectListApiData] = useState({
    organisationId: ORG_ID(),
    page: 1,
    pageSize: pageSize,
    search: "",
    startDate: "",
    endDate: "",
    siteId: "",
    customerId: clients ? clients : swCustomerId,
    status: "",
    divisionId: divisionId ?? "",
    stateId: "",
  });

  const autoCompSupervisor = useRef(null);
  const [changesearchautoClient, setChangesearchautoClient] = useState({
    key: "",
    value: "",
  });

  const onSelectSearchCustomer = (e, value, reason) => {
    if (reason === "clear") {
      setChangesearchautoClient({ key: "", value: "" });
      setClients("");

      const data = {
        ...swProjectListData?.filterObj,
        customerId: 0,
        status: "",
        customerName: "",
      };

      swProjectLists(data);
      return;
    }
    setChangesearchautoClient({
      key: value?.key ?? "",
      value: value?.value ?? "",
    });
    setClients(value?.key || 0);
    const data = {
      page: 1,
      pageSize: pageSize,
      customerId: value?.key || 0,
      customerName: value?.value || "",
      startDate: searchdata?.startDate || "",
      endDate: searchdata?.endDate || "",
      status: searchdata?.status || "",
      stateId: searchdata?.stateId || "",
      search: "",
      divisionId: divisionId ?? "",
    };
    swProjectLists(data);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const deletehandle = () => {
    setOpenModal(false);
    deleteSWProject(selectedRow.projectId);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handlePagignation = (newPage) => {
    const savedFilter = swProjectListData?.filterObj || {};
    const safePage = newPage < 0 ? 0 : newPage;
    setPage(safePage);
    // setPage(newPage);
    setSwProjectListApiData({
      ...swProjectListApiData,
      page: safePage + 1,
      pageSize: pageSize,
      siteId: siteName,
    });
    const data = {
      ...swProjectListApiData,
      customerId: clients ? clients : swCustomerId,
      customerName: changesearchautoClient?.value || "",
      siteId: siteName,
      siteName: changesearchauto?.value || "",
      page: safePage + 1,
      pageSize: pageSize,
      startDate: savedFilter?.startDate ?? searchdata?.startDate ?? "",
      endDate: savedFilter?.endDate ?? searchdata?.endDate ?? "",
      status: savedFilter?.status ?? searchdata?.status ?? "",
      stateId: savedFilter?.stateId ?? searchdata?.stateId ?? "",
      search: search ? search : "",
      divisionId: divisionId ?? "",
    };

    swProjectLists(data);
  };

  const handlePageSizeChange = (newPageSize) => {
    const savedFilter = swProjectListData?.filterObj || {};
    setPageSize(newPageSize);
    setPage(0);
    const data = {
      ...swProjectListApiData,
      page: 1,
      pageSize: newPageSize,
      customerId: clients ? clients : swCustomerId,

      customerName: changesearchautoClient?.value || "",
      siteId: siteName,
      siteName: changesearchauto?.value || "",
      startDate: savedFilter?.startDate ?? searchdata?.startDate ?? "",
      endDate: savedFilter?.endDate ?? searchdata?.endDate ?? "",
      status: savedFilter?.status ?? searchdata?.status ?? "",
      stateId: savedFilter?.stateId ?? searchdata?.stateId ?? "",
      search: search ? search : "",
      divisionId: divisionId ?? "",
    };
    setSwProjectListApiData(data);
    swProjectLists(data);
  };

  const deleteProject = (rows, name) => {
    if (InactiveClient()) return;
    if (!rows?.isClientActive) {
      toast("This Client is Inactive");
      return true;
    }
    sessionStorage.setItem("swProjectListPreserveState", "true");
    setOpenModal(true);
    setSelectedRow(rows);
    setProjectName(name);
  };

  const handleautoSearch = (event) => {
    let searchText = event.target.value || "";
    setSearch(searchText);
    setPage(0);
  };
  const handleOnEditclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("swProjectListPreserveState", "true");
    navigate(ADMIN_ADD_STORM_WATERPROJECT, {
      state: {
        projectid: rows.row.projectId,
        customerId: rows.row.customerId,
        customerName: rows.row.customer,
        editMode: true,
        stateId: rows.row.stateId,
        clients: rows?.row?.customerId,
        projectNumber: rows?.row?.projectNumber,
        projectName: rows?.row?.name,
      },
    });
  };

  const handleOnViewclick = (rows) => {
    sessionStorage.setItem("swProjectListPreserveState", "true");
    navigate(ADMIN_SW_VIEW_PROJECT, {
      state: {
        projectid: rows.row.projectId,
        customerId: rows.row.customerId,
        customerName: rows.row.customer,
        editMode: true,
        stateId: rows.row.stateId,
        clients: rows?.row?.customerId,
        projectNumber: rows?.row?.projectNumber,
        projectName: rows?.row?.name,
      },
    });
  };
  const handleOnAddclick = (rows) => {
    if (InactiveClient()) return;
    if (!rows?.row?.isClientActive) {
      toast("This Client is Inactive");
      return true;
    }
    navigate(SW_ADD_PERMIT, {
      state: {
        projectid: rows.row.projectId,
        stateId: rows.row.stateId,
        projectNumber: rows.row.projectNumber,
        projectName: rows.row.name,
        state: rows.row.state,
        customerId: rows.row.customerId,
        customerName: rows.row.customer,
      },
    });
  };
  const handleOnViewSampleclick = (rows) => {
    if (InactiveClient()) return;
    if (!rows?.row?.isClientActive) {
      toast("This Client is Inactive");
      return true;
    }
    navigate(SW_ADMIN_SAMPLINGLOG, {
      state: {
        projectId: rows?.row?.projectId,
        stateId: rows.row.stateId,
        projectNumber: rows.row.projectNumber,
        projectName: rows.row.name,
        state: rows.row.state,
      },
    });
  };
  const swProjectcolumns = [
    { field: "projectId", headerName: "Project ID", flex: 1 },
    { field: "customer", headerName: "Client", flex: 1 },
    {
      field: "site",
      headerName: "Site",
      flex: 1.3,
      renderCell: (rows) => {
        return <div>{rows?.row?.site ? rows?.row?.site : "N/A"}</div>;
      },
    },
    { field: "name", headerName: "Project Name", flex: 1.3 },
    { field: "city", headerName: "City", flex: 1 },

    { field: "state", headerName: "State", flex: 1 },
    { field: "startDate", headerName: "Start Date", flex: 1.2 },
    {
      field: "status",
      headerName: "Status",
      renderCell: (rows) => {
        return <div>{rows?.row?.isActive ? "Active" : "InActive"}</div>;
      },
      flex: 0.8,
    },

    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={swProjectListData?.data?.itemsCount ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={swProjectListData?.data?.projects ?? []}
          fileNameXL={"ProjectList"}
        />
      ),
      width: 70,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            credentialLists={true}
            view={checkPrivileges([12, 113, 111, 112])}
            viewOnClick={() => handleOnViewclick(rows)}
            viewLabel={"View Project"}
            editOnClick={() => handleOnEditclick(rows)}
            deleteOnClick={() => deleteProject(rows?.row, rows?.row?.name)}
            addForm={() => handleOnAddclick(rows)}
            edit={checkPrivileges([12, 111, 112])}
            editLabel="Manage Project"
            download={false}
            addBtn={checkPrivileges([12, 126, 127])}
            addBtnLabel="Add Project Permit"
            sampleLog={
              rows?.row?.isSamplingRequired == true &&
              checkPrivileges([12, 129, 130, 131])
                ? true
                : false
            }
            sampleLogOnClick={() => handleOnViewSampleclick(rows)}
            deleteLabel="Delete Project"
            deleted={checkPrivileges([12, 111])}
          />
        );
      },
    },
  ];

  const handleSearchs = (data) => {
    setAnchorEl(null);
    let filterdata = data;
    filterdata["startDate"] = filterdata?.startDate
      ? getFormatedDate(filterdata?.startDate)
      : "";
    filterdata["endDate"] = filterdata?.endDate
      ? getFormatedDate(filterdata?.endDate)
      : "";

    const newdata = {
      ...filterdata,
      page: 1,
      pageSize: pageSize,
      customerName: changesearchautoClient ? changesearchautoClient.value : "",
      customerId: clients ? clients : swCustomerId,
      siteId: siteName,
      siteName: changesearchauto?.value ? changesearchauto.value : "",
      search: filterdata?.search ?? "",
    };
    setSearchdata(newdata);
    setPage(0);
    swProjectLists(newdata);
  };
  const typeOnchange = (event) => {
    const inputValue = String(event.target?.value || "").trim();
    if (inputValue) {
      setClientSearch(inputValue);
    }
  };
  const handleAllSearchSearch = (event) => {
    const inputValue = String(event.target?.value || "").trim();
    setSiteSearch(inputValue);
  };
  const [changesearchauto, setchangesearchauto] = useState({
    key: "",
    value: "",
  });

  const onSelectSearchSite = (e, value, reason) => {
    if (reason === "clear") {
      setchangesearchauto({ key: "", value: "" });
      setSiteName("");

      const data = {
        ...swProjectListData?.filterObj,
        siteId: "",
        siteName: "",
      };

      swProjectLists(data);
      return;
    }

    setchangesearchauto({ key: value?.key ?? "", value: value?.value ?? "" });

    setSiteName(value?.key || null);
    const data1 = {
      organisationId: ORG_ID(),
      page: 1,
      pageSize: pageSize,
      search: "",
      startDate: "",
      endDate: "",
      siteId: value?.key || null,
      siteName: value?.value || "",
      customerName: swProjectListData.filterObj?.customerName ?? "",
      customerId: clients ? clients : swCustomerId,
      divisionId: divisionId ?? "",
      stateId: swProjectListData.filterObj?.stateId ?? searchdata?.stateId ?? "",
    };
    swProjectLists(data1);
  };
  // for qr code
  const [accessUserId, setAccessUserId] = useState([]);
  const selectedRowsData = swProjectListData?.data?.projects.filter((row) =>
    accessUserId.includes(row.projectId),
  );

  const projectData = selectedRowsData?.map((project) => ({
    id: project?.projectId,
    projectNumber: project.projectNumber,
    projectName: project.name,
    clientname: project?.customer,
  }));

  const [anchorElqr, setAnchorElqr] = useState(null);
  const openQr = Boolean(anchorElqr);
  const idQr = openQr ? "simple-popover" : undefined;

  const qrCodeRef = useRef(null);
  const onClickQrCodeDownload = (event) => {
    setAnchorElqr(event.currentTarget);
  };

  const handleCloseQr = () => {
    setAnchorElqr(null);
  };

  const handleDownloadAsPDF = () => {
    if (selectedRowsData?.length === 0) {
      return;
    }
    qrCodeRef.current?.(projectData, "pdf");
    handleCloseQr();
  };

  const handleDownloadAsPNG = () => {
    if (selectedRowsData?.length === 0) {
      return;
    }
    qrCodeRef.current?.(projectData, "png");
    handleCloseQr();
  };

  useEffect(() => {
    if (shouldRestoreState && swProjectListData?.filterObj) {
      const filter = swProjectListData.filterObj;
      setSearch(filter.search || "");
      const restoredPage = filter.page ?? 1;
      setPage(restoredPage > 0 ? restoredPage - 1 : 0);
      setPageSize(filter.pageSize || GRID_DEFAULT_PAGE_SIZE);

      if (filter.customerId) {
        setClients(filter.customerId);
        setChangesearchautoClient((prev) => ({
          key: filter.customerId,
          value: filter.customerName ?? prev.value,
        }));
      }

      if (filter.siteId) {
        setSiteName(filter.siteId);
        setchangesearchauto((prev) => ({
          key: filter.siteId,
          value: filter.siteName ?? prev.value,
        }));
      }

      if (filter.startDate || filter.endDate || filter.status || filter.stateId) {
        setSearchdata({
          startDate: filter.startDate || "",
          endDate: filter.endDate || "",
          status: filter.status || "",
          stateId: filter.stateId || "",
        });
      }
    } else if (shouldRestoreState === false) {
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      setClients("");
      setSiteName("");
      setChangesearchautoClient({ key: "", value: "" });
      setchangesearchauto({ key: "", value: "" });
      setSearchdata({});
    }
  }, [shouldRestoreState]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const savedFilter = swProjectListData?.filterObj || {};

    const data = {
      ...swProjectListApiData,
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch || "",
      customerId: clients ? clients : swCustomerId,
      customerName: changesearchautoClient?.value || "",
      siteId: siteName,
      siteName: changesearchauto?.value || "",
      startDate: savedFilter?.startDate ?? searchdata?.startDate ?? "",
      endDate: savedFilter?.endDate ?? searchdata?.endDate ?? "",
      status: savedFilter?.status ?? searchdata?.status ?? "",
      stateId: savedFilter?.stateId ?? searchdata?.stateId ?? "",
      divisionId: divisionId ?? "",
    };

    setSwProjectListApiData(data);
    setPage(0);
    swProjectLists(data);
  }, [debouncedSearch]);

  const isFirstClientRender = useRef(true);

  useEffect(() => {
    if (isFirstClientRender.current) {
      isFirstClientRender.current = false;
      return;
    }
    if (!debouncedClientSearch) return;
    searchClient(debouncedClientSearch);
  }, [debouncedClientSearch]);

  const isFirstSiteRender = useRef(true);

  useEffect(() => {
    if (isFirstSiteRender.current) {
      isFirstSiteRender.current = false;
      return;
    }
    if (!debouncedSiteSearch) return;
    const defaultdata = {
      search: debouncedSiteSearch,
      customerId: clients ? clients : null,
    };

    onSearchSite(defaultdata);
  }, [debouncedSiteSearch]);

  return (
    <>
      <section className="grid_main_sec" data-testid="sw-project-list-page">
        <div className="grid_main_body">
          <Grid item container mt={2} mb={3} className="swprojectSearchField">
            {parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
              checkPrivileges([12, 17]) && (
                <Grid item lg={4} xs={12} sm={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabels label="Client" isRequired={false} />
                    <SearchAutoComplete
                      name="Customer"
                      optionsData={
                        autoSearchDataLoading
                          ? []
                          : (searchAllClientsReducerData?.data ?? [])
                      }
                      typeOnchange={(event, value) => typeOnchange(event)}
                      isKeyValuePair={true}
                      value={
                        changesearchautoClient ? changesearchautoClient : ""
                      }
                      onChange={(event, value, key) =>
                        onSelectSearchCustomer(event, value, key)
                      }
                      isLoading={autoSearchDataLoading}
                      noOptionsTextMsg="No Client"
                      autoCompClear={autoCompGroup}
                    />
                  </FormControl>
                </Grid>
              )}
            {parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
              checkPrivileges([12, 17]) && (
                <Grid item lg={4} xs={12} sm={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabels label="Site" isRequired={false} />
                    <SearchAutoComplete
                      name="Site"
                      isKeyValuePair={true}
                      typeOnchange={(event, value) =>
                        handleAllSearchSearch(event)
                      }
                      optionsData={searchSitedata}
                      isLoading={isLoading}
                      noOptionsTextMsg="No Site"
                      onChange={(event, value, key) =>
                        onSelectSearchSite(event, value, key)
                      }
                      value={changesearchauto ? changesearchauto : ""}
                      autoCompClear={autoCompSupervisor}
                    />
                  </FormControl>
                </Grid>
              )}
          </Grid>
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              header={"Confirm Deletion"}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              content={`Are you sure you want to delete this Project ${projectName}  ?`}
              view
            />
          )}
          <Grid
            item
            container
            lg={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item lg={9} xs={12} md={7}>
              <div className="filter_of_caselist">
                <div className="searchcaseid">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>
                    <div>
                      <input
                        id="search"
                        placeholder="Search Projects, City, Project No."
                        type="text"
                        value={search}
                        className=""
                        onChange={handleautoSearch}
                        autoComplete="off"
                      />
                    </div>
                  </label>
                </div>

                <div className="filter_btn">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>
                  <SiteFilter
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleSearch={handleSearchs}
                    handleClose={handleClose}
                    issite={true}
                    clients={clients}
                    search={search}
                    filterObj={swProjectListData?.filterObj}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    setSearch={setSearch}
                    stateFilterList={stateList}
                  />
                </div>
              </div>
            </Grid>

            {accessUserId?.length >= 1 && (
              <Grid
                item
                lg={3}
                xs={12}
                md={5}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: { xs: "16px 8px", sm: "16px 16px", lg: "0" },
                  paddingBottom: { xs: "20px", sm: "30px", lg: "20px" },
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: "44px",
                    backgroundColor: "#34A853",
                    color: "white",
                    borderRadius: "100px",
                    textTransform: "none",
                    boxShadow: "none",
                    transition: "none",
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "0px 38px",
                    width: "auto",
                    whiteSpace: "nowrap",
                    flexGrow: 0,
                  }}
                  onClick={onClickQrCodeDownload}
                >
                  Download QR Codes
                </Button>
                <Popover
                  id={idQr}
                  open={openQr}
                  anchorEl={anchorElqr}
                  onClose={handleCloseQr}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ cursor: "pointer", color: "#333333" }}
                      onClick={handleDownloadAsPDF}
                    >
                      Download PDF
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ cursor: "pointer", color: "#333333" }}
                      onClick={handleDownloadAsPNG}
                    >
                      Download PNG
                    </Typography>
                  </Box>
                </Popover>
              </Grid>
            )}
          </Grid>

          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              <GridTable
                getRowId={(r) => r.projectId}
                rows={swProjectListData?.data?.projects ?? []}
                rowCount={swProjectListData?.data?.itemsCount ?? 0}
                columns={swProjectcolumns}
                loading={isLoading}
                checkboxSelection={true}
                page={page}
                pagination
                pageSize={pageSize}
                rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePagignation}
                backIconButtonProps={{ disabled: false }}
                disableSelectionOnClick={true}
                selectionModel={accessUserId}
                onSelectionModelChange={(selection) => {
                  setAccessUserId(selection);
                }}
                components={{
                  LoadingOverlay: TableLoader,
                  NoRowsOverlay: NORow,
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ display: "none" }}>
          <QrCodeDownload ref={qrCodeRef} projectData={projectData} />
        </div>
      </section>
    </>
  );
}
